import BrowserDetectData from 'gw-portals-featuredetection-js/browserdetect/BrowserDetectData';

export default (function (window) {
   return {};
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-js/adapters/AltocloudAnalyticsAdapter.js
// module id = 917
// module chunks = 0